{
  "newAnnouncement": "새로운 공지 있음",
  "notification": "알림 및 공지",
  "unread": "읽지 않은 알림"
}
